import React from 'react'
import './index.css'
import classNames from 'classnames'
import logEventAnalyticsUtil from 'utils/analytics/log-event'
import H2 from 'components/H2'
import Flex from 'components/Flex'
import useSelector from 'hooks/use-selector'
import getMembersSquadSelect from 'modules/squad/redux/selectors/get-members'
import getCurrentMemberIdSquadSelect from 'modules/squad/redux/selectors/get-current-member-id'
import Button from 'components/Button'
import updateCurrentMemberIdSquadAction from 'modules/squad/redux/actions/update-current-member-id'
import useDispatch from 'hooks/use-dispatch'
import FlexColumn from 'components/FlexColumn'
import useIsMediumScreen from 'hooks/use-is-medium-screen'
import SquadPageSelectAFriend from 'pages/Squad/containers/Friends/SelectAFriend'
import logUtil from 'utils/log'
import runAfterDelayTimingUtil from 'utils/timing/run-after-delay'
import getInitialFriendIndexUtil from 'pages/Squad/containers/Friends/Names/utils/get-initial-friend-index'
import getMemberNameSquadUtil from 'modules/squad/utils/get-member-name'
import registerSwiperUtil from 'utils/swiper/register'

const ANALYTICS_EVENT = {
  SELECT_FRIEND: 'SELECT_FRIEND',
  SELECT_FRIEND_PICKER: 'SELECT_FRIEND_PICKER',
  PREVIOUS_FRIEND: 'PREVIOUS_FRIEND',
  NEXT_FRIEND: 'NEXT_FRIEND'
}
export default function SquadPageFriendNames () {
  const dispatch = useDispatch()
  /**
   * @type {import('modules/squad/types').GetSquadInfoResp.squad_members}
   */
  const members = useSelector(getMembersSquadSelect)
  const selectedMemberId = useSelector(getCurrentMemberIdSquadSelect)
  const isMediumScreen = useIsMediumScreen()
  const initialFriendIndex = getInitialFriendIndexUtil({ members })
  const debugProps = {
    members,
    selectedMemberId,
    isMediumScreen,
    initialFriendIndex
  }

  logUtil('SquadPageFriendNames').debug('[start] debugProps=', debugProps)
  const swiperElRef = React.useRef()
  const [activeItemIndex, setActiveItemIndex] = React.useState(0)

  const handleClickFriend = (index) => {
    logUtil('SquadPageFriendNames#handleClickFriend').debug(`[start] index=${index}`)
    swiperElRef.current?.swiper?.slideTo?.(index)
    logEventAnalyticsUtil(ANALYTICS_EVENT.SELECT_FRIEND)
  }

  const handleClickFriendPicker = (index) => {
    logUtil('SquadPageFriendNames#handleClickFriendPicker').debug(`[start] index=${index}`)
    swiperElRef.current?.swiper?.slideTo?.(index)
    logEventAnalyticsUtil(ANALYTICS_EVENT.SELECT_FRIEND_PICKER)
  }

  const swipeToInitialFriend = async () => {
    if (initialFriendIndex == null || initialFriendIndex === -1) {
      return
    }
    await runAfterDelayTimingUtil(0)
    swiperElRef.current?.swiper?.slideTo?.(initialFriendIndex)
  }

  React.useEffect(() => {
    registerSwiperUtil()

    const handleChange = event => {
      let activeIndex = event.detail?.[0]?.activeIndex
      logUtil('SquadPageSelectAFriend#handleChange').debug('activeIndex=', activeIndex)
      if (isNaN(activeIndex)) {
        activeIndex = 1
      }
      if (activeIndex == null) {
        return
      }
      setActiveItemIndex(activeIndex)
      dispatch(updateCurrentMemberIdSquadAction(members[activeIndex].squad_member_customer_id))
    }
    swiperElRef.current?.addEventListener('slidechange', handleChange)

    swipeToInitialFriend()
    return () => {
      swiperElRef.current?.removeEventListener('slidechange', handleChange)
    }
  }, [])

  const handleClickPrevious = () => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.PREVIOUS_FRIEND)
    swiperElRef.current?.swiper?.slideTo?.(activeItemIndex - 1)
  }
  const handleClickNext = () => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.NEXT_FRIEND)
    swiperElRef.current?.swiper?.slideTo?.(activeItemIndex + 1)
  }

  return (
    <FlexColumn
      className='squad-friend-names'
    >
      <Flex
        className='squad-friend-names-list'
        style={{
          // width: `${(isMediumScreen ? 75 : 100) * members.length}vw`
          width: '100vw'
        }}
      >
        <swiper-container
          // slides-per-view={isMediumScreen ? '2' : '3'}
          slides-per-view='1'
          ref={swiperElRef}
          style={{
            zIndex: 0,
            SwiperPaginationColor: 'white'
          }}
          watch-overflow={false}
          watchOverflow={false}
          pagination={false}
        >
          {members.map((member, index) => {
            const id = member.squad_member_customer_id
            const isSelected = id === selectedMemberId
            return (
              <swiper-slide key={`${id}-${index}`}>
                <Button
                  key={id}
                  onClick={() => handleClickFriend(index)}
                  className={
                    classNames({
                      'squad-friend-names-item': true,
                      'squad-friend-names-item_selected': isSelected
                    })
                  }
                >
                  <H2>
                    {getMemberNameSquadUtil(member)}
                  </H2>
                </Button>
              </swiper-slide>
            )
          })}
        </swiper-container>
      </Flex>
      <SquadPageSelectAFriend
        onClickPrevious={handleClickPrevious}
        onClickNext={handleClickNext}
        onClickFriend={handleClickFriendPicker}
      />
    </FlexColumn>
  )
}
